<template>
  <g>
    <g>
      <g id="fuel_deviation">
        <path class="st1" d="M12,3c-5,0-9,4-9,9s4,9,9,9s9-4,9-9S17,3,12,3z M12,19.7c-1.9,0-3.7-0.7-5.1-1.9l1.4-1.4
					c-0.1-0.2-0.2-0.5-0.2-0.7v-0.9L6,16.9c-1.1-1.3-1.8-3.1-1.8-4.9c0-4.3,3.5-7.7,7.7-7.7c1.9,0,3.6,0.7,4.9,1.8l-2.4,2.4l0.9,0.9
					l2.4-2.4c1.2,1.4,1.9,3.1,1.9,5.1C19.7,16.3,16.3,19.7,12,19.7z"/>
				<path class="st1" d="M15,9.8l-0.9-0.9l-0.6-0.6C13.3,8.1,13.1,8,12.9,8h-1.5V7.5c0-0.4-0.3-0.8-0.8-0.8H9.5
					c-0.4,0-0.8,0.3-0.8,0.8v6.7v1.4c0,0.1,0,0.2,0,0.3c0.1,0.4,0.5,0.6,0.9,0.6H15c0.5,0,0.9-0.4,0.9-0.9V11c0-0.2-0.1-0.4-0.2-0.5
					L15,9.8z M9.4,15.7v-0.3v-1.8V8.7v0h3.5c0,0,0,0,0,0l0.6,0.6l0.9,0.9l0.7,0.7c0,0,0,0,0,0v4.7c0,0.1-0.1,0.2-0.2,0.2H9.6
					c0,0,0,0-0.1,0C9.5,15.9,9.4,15.8,9.4,15.7z M10.7,7.5C10.8,7.5,10.8,7.5,10.7,7.5L10.8,8H9.4V7.5c0,0,0-0.1,0.1-0.1H10.7z"/>
				<path class="st1" d="M12.8,10.2l0.9,0.9l0.4,0.4c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0.1-0.4,0-0.5l-0.4-0.4
					l-0.9-0.9l-0.3-0.3c-0.1-0.1-0.4-0.1-0.5,0c-0.1,0.1-0.1,0.4,0,0.5L12.8,10.2z"/>
				<path class="st1" d="M10.8,14.3c0.3,0.6,0.8,1,1.5,1s1.2-0.4,1.5-1c0.3-0.6,0.2-1.3-0.2-1.8L13,11.8l-0.4-0.5
					c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0.1l-1,1.2c-0.4,0.4-0.5,1-0.3,1.5C10.7,14.1,10.8,14.2,10.8,14.3z M11.4,13.4
					c0-0.2,0.1-0.3,0.2-0.5l0.7-0.9l0.2,0.2l0.6,0.7c0.3,0.3,0.3,0.7,0.1,1s-0.5,0.6-0.9,0.6c-0.4,0-0.7-0.2-0.9-0.6
					C11.3,13.8,11.3,13.6,11.4,13.4z"/>
      </g>
      <rect
        width="24"
        height="24"
        fill="#E3E3E3"
        fill-opacity=".01"
        style="mix-blend-mode:color-burn"
      />
      <use :fill="currentColor" :opacity="opacity" xlink:href="#fuel_deviation@1x-a" />
    </g>
  </g>
</template>

<script>
  export default {
    props: {
      currentColor: {
        type: String,
        default: 'black'
      },
      opacity: {
        type: String,
        default: '1'
      }
    }  
  }
</script>